import React, { FC, useEffect, useState } from 'react';
import Modal from 'components/commercetools-ui/atoms/modal';
import Markdown from 'components/commercetools-ui/organisms/markdown';

export type PopupItem = {
  popup_id?: string;
  popupId?: string;
  title?: string;
  content?: string;
  footer_text?: string;
  footerText?: string;
  button_text?: string;
  buttonText?: string;
  button_url?: string;
  buttonUrl?: string;
};

export type PopupsProps = {
  data?: {
    popups?: PopupItem[];
    [key: string]: any;
  } | any;
};

const PDPPopups: FC<PopupsProps> = ({ data }) => {
  const [openPopupId, setOpenPopupId] = useState<string | null>(null);

  useEffect(() => {
    const handleOpenPopup = (event: CustomEvent<{ popupId: string }>) => {
      if (event.detail?.popupId) {
        setOpenPopupId(event.detail.popupId);
      }
    };

    window.addEventListener('open-pdp-popup' as any, handleOpenPopup as any);
    return () => {
      window.removeEventListener('open-pdp-popup' as any, handleOpenPopup as any);
    };
  }, []);

  const extractPopups = (input: any): PopupItem[] => {
    if (Array.isArray(input?.popups)) return input.popups;
    if (Array.isArray(input?.data?.dataSource?.popups)) return input.data.dataSource.popups;
    return [];
  };

  const popupsList = extractPopups(data);

  const matchedPopup = popupsList.find(
    (item: any) =>
      item?.popup_id === openPopupId ||
      item?.popupId === openPopupId ||
      (openPopupId?.includes('rivier') && (item?.popup_id?.includes('rivier') || item?.popupId?.includes('rivier')))
  ) || (openPopupId && popupsList.length > 0 ? popupsList[0] : null);

  if (!openPopupId) return null;

  const activePopup: PopupItem | null = matchedPopup || (popupsList.length > 0 ? popupsList[0] : null);

  const title = activePopup?.title;
  const content = activePopup?.content;
  const footerText = activePopup?.footer_text || activePopup?.footerText;
  const buttonText = activePopup?.button_text || activePopup?.buttonText;
  const buttonUrl = activePopup?.button_url || activePopup?.buttonUrl;

  return (
    <Modal
      isOpen={!!openPopupId}
      onRequestClose={() => setOpenPopupId(null)}
      closeButton
    >
      <div className="rounded-[16px] bg-white p-24 text-left md:p-32 max-h-[80vh] overflow-y-auto">
        {title && (
          <h2 className="text-24 font-semibold text-[#090909] md:text-28">
            {title}
          </h2>
        )}

        {content && (
          <div className="mt-12 text-14 leading-6 text-[#333333] md:text-16">
            <Markdown markdown={content} />
          </div>
        )}

        {(footerText || buttonText) && (
          <div className="mt-8 border-t pt-6">
            {footerText && (
              <p className="text-14 text-[#666666] md:text-16">
                {footerText}
              </p>
            )}

            {buttonText && (
              <a
                href={buttonUrl || '#'}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-5 inline-flex items-center justify-center rounded-full bg-black px-20 py-12 text-14 font-semibold text-white transition hover:bg-neutral-900 md:text-16"
              >
                {buttonText}
              </a>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default PDPPopups;
